import React, { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';

const UtmDetails = ({ row }) => {
    const [expanded, setExpanded] = useState(false);

    if (!row) return 'N/A';

    // Helper to parse raw_utm
    const getUtmData = () => {
        const raw = row.raw_utm || (row.user && row.user.raw_utm);
        if (!raw) return {};
        if (typeof raw === 'object') return raw;
        try {
            return JSON.parse(raw);
        } catch (e) {
            return {};
        }
    };

    const utmData = getUtmData();

    // Combine data sources
    const combined = {
        ...utmData,
        page_type: row.page_type || (row.user && row.user.page_type) || utmData.page_type,
        utm_source: row.utm_source || (row.user && row.user.utm_source) || utmData.utm_source || utmData.source,
        utm_medium: row.utm_medium || (row.user && row.user.utm_medium) || utmData.utm_medium || utmData.medium,
        utm_campaignid: row.utm_campaignid || (row.user && row.user.utm_campaignid) || row.utm_campaign_id || utmData.utm_campaignid || utmData.campaign_id,
        utm_campaign: row.utm_campaign || utmData.utm_campaign,
        adgroup_id: row.adgroup_id || row.adgroupid || utmData.adgroupid || utmData.adgroup_id,
        country: row.country || (row.user && row.user.country) || utmData.country,
        city: row.city || (row.user && row.user.city) || utmData.city,
    };

    const mainFields = [
        { label: 'Page Type', value: combined.page_type },
        { label: 'Utm Source', value: combined.utm_source },
        { label: 'Utm Medium', value: combined.utm_medium },
        { label: 'Utm Campaignid', value: combined.utm_campaignid },
    ].filter(f => f.value);

    // Identify shown keys to filter them out of extraFields
    const shownKeys = ['page_type', 'utm_source', 'utm_medium', 'utm_campaignid', 'utm_campaign_id', 'source', 'medium', 'campaign_id'];

    const extraFields = Object.entries(combined)
        .filter(([k, v]) => {
            const key = k.toLowerCase();
            return v && v !== "" && !shownKeys.includes(key);
        })
        .map(([k, v]) => ({
            label: k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
            value: v
        }));

    if (mainFields.length === 0 && extraFields.length === 0) return 'N/A';

    return (
        <Box sx={{ fontSize: '0.85rem', lineHeight: 1.4 }}>
            {mainFields.map((field, i) => (
                <div key={i}>
                    <strong>{field.label}:</strong> {field.value}
                </div>
            ))}

            {extraFields.length > 0 && (
                <>
                    {!expanded && (
                        <Box
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(true);
                            }}
                            sx={{
                                cursor: 'pointer',
                                color: 'primary.main',
                                fontWeight: 'bold',
                                fontSize: '0.8rem',
                                lineHeight: 0.5,
                                mt: 2,
                                mb: 0.5,
                                '&:hover': { color: 'primary.dark' }
                            }}
                        >
                            View More . . .
                        </Box>
                    )}
                    <Collapse in={expanded}>
                        <Box sx={{ mt: 0.5 }}>
                            {extraFields.map((field, i) => (
                                <div key={i}>
                                    <strong>{field.label}:</strong> {field.value}
                                </div>
                            ))}
                            <Box
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setExpanded(false);
                                }}
                                sx={{
                                    cursor: 'pointer',
                                    color: 'primary.main',
                                    fontSize: '0.75rem',
                                    mt: 0.5,
                                    textDecoration: 'underline',
                                    '&:hover': { color: 'primary.dark' }
                                }}
                            >
                                Show Less
                            </Box>
                        </Box>
                    </Collapse>
                </>
            )}
        </Box>
    );
};

export default UtmDetails;
